export var ADD_NEW_FILTER = 'ADD_NEW_FILTER';
export var RESET_FILTER = 'RESET_FILTERS';
export var APPLY_FILTERS = 'APPLY_FILTERS';